import React, { Component } from 'react';
import { apiInterfaceForJson } from '../../../services/common/apiManager';

class LegacyLimitlisGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            patients: [],
            total: 0,
            search: '',
            loading: false,
            stats: null,
            selectedPatient: null,
            selectedRequisition: null,
            requisitions: [],
            loadingReqs: false,
        };
    }

    componentDidMount() {
        this.loadStats();
        this.loadPatients();
    }

    loadStats = () => {
        apiInterfaceForJson('/legacyLimitlis/stats', 'GET').then(res => {
            if (res && res.data) this.setState({ stats: res.data });
        });
    }

    loadPatients = () => {
        this.setState({ loading: true });
        apiInterfaceForJson('/legacyLimitlis/patients/search', 'POST', {
            search: this.state.search,
            limit: 100
        }).then(res => {
            if (res && res.data) {
                this.setState({ patients: res.data, total: res.total, loading: false });
            }
        }).catch(() => this.setState({ loading: false }));
    }

    handleSearch = (e) => {
        e.preventDefault();
        this.loadPatients();
    }

    selectPatient = (patient) => {
        this.setState({ selectedPatient: patient, loadingReqs: true, requisitions: [], selectedRequisition: null });
        apiInterfaceForJson(`/legacyLimitlis/patients/${patient.mrn}/requisitions`, 'GET').then(res => {
            if (res && res.data) this.setState({ requisitions: res.data, loadingReqs: false });
        }).catch(() => this.setState({ loadingReqs: false }));
    }

    formatDate = (date) => {
        if (!date) return '-';
        return new Date(date).toLocaleDateString();
    }

    printRequisition = (req) => {
        const { selectedPatient } = this.state;
        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
            <html>
            <head>
                <title>Legacy Requisition - ${req.barcode}</title>
                <style>
                    body { font-family: Arial, sans-serif; font-size: 12px; padding: 20px; color: #000; }
                    .header { text-align: center; border-bottom: 2px solid #000; padding-bottom: 10px; margin-bottom: 15px; }
                    .header h2 { margin: 0; font-size: 18px; }
                    .header p { margin: 2px 0; font-size: 11px; color: #666; }
                    .section { margin-bottom: 15px; }
                    .section-title { font-weight: bold; font-size: 13px; border-bottom: 1px solid #ccc; padding-bottom: 3px; margin-bottom: 8px; background: #f0f0f0; padding: 4px; }
                    .row { display: flex; margin-bottom: 5px; }
                    .label { font-weight: bold; width: 160px; flex-shrink: 0; }
                    .value { flex: 1; }
                    .badge { display: inline-block; padding: 2px 8px; border-radius: 3px; font-size: 11px; font-weight: bold; }
                    .badge-released { background: #d4edda; color: #155724; border: 1px solid #c3e6cb; }
                    .badge-pending { background: #fff3cd; color: #856404; border: 1px solid #ffeeba; }
                    .footer { margin-top: 30px; border-top: 1px solid #ccc; padding-top: 10px; font-size: 10px; color: #666; text-align: center; }
                    .legacy-badge { background: #e2e3e5; border: 1px solid #adb5bd; color: #383d41; padding: 2px 8px; border-radius: 3px; font-size: 10px; }
                    @media print { button { display: none; } }
                </style>
            </head>
            <body>
                <div class="header">
                    <h2>Rhein Consulting Laboratories</h2>
                    <p>Legacy LimitLIS Requisition <span class="legacy-badge">LEGACY RECORD</span></p>
                </div>

                <div class="section">
                    <div class="section-title">Requisition Information</div>
                    <div class="row"><span class="label">Barcode:</span><span class="value"><strong>${req.barcode}</strong></span></div>
                    <div class="row"><span class="label">Status:</span><span class="value"><span class="badge badge-${req.status}">${req.status?.toUpperCase()}</span></span></div>
                    <div class="row"><span class="label">Collection Date:</span><span class="value">${this.formatDate(req.collection_date)}</span></div>
                    <div class="row"><span class="label">Received Date:</span><span class="value">${this.formatDate(req.received_date)}</span></div>
                    <div class="row"><span class="label">Released Date:</span><span class="value">${this.formatDate(req.released_date)}</span></div>
                    <div class="row"><span class="label">Report Date:</span><span class="value">${this.formatDate(req.report_date)}</span></div>
                    ${req.specimen_types ? `<div class="row"><span class="label">Specimen Types:</span><span class="value">${req.specimen_types}</span></div>` : ''}
                </div>

                ${selectedPatient ? `
                <div class="section">
                    <div class="section-title">Patient Information</div>
                    <div class="row"><span class="label">Name:</span><span class="value">${selectedPatient.last_name}, ${selectedPatient.first_name} ${selectedPatient.middle_name || ''}</span></div>
                    <div class="row"><span class="label">MRN:</span><span class="value">${selectedPatient.mrn}</span></div>
                    <div class="row"><span class="label">Date of Birth:</span><span class="value">${this.formatDate(selectedPatient.date_of_birth)}</span></div>
                    <div class="row"><span class="label">Sex:</span><span class="value">${selectedPatient.sex || '-'}</span></div>
                    <div class="row"><span class="label">Phone:</span><span class="value">${selectedPatient.phone || '-'}</span></div>
                    <div class="row"><span class="label">Address:</span><span class="value">${selectedPatient.address || '-'}</span></div>
                </div>` : ''}

                ${req.diagnoses ? `
                <div class="section">
                    <div class="section-title">Diagnoses</div>
                    <div style="line-height: 1.6;">${req.diagnoses}</div>
                </div>` : ''}

                ${req.comments ? `
                <div class="section">
                    <div class="section-title">Comments</div>
                    <div>${req.comments}</div>
                </div>` : ''}

                ${req.cancellation_comments ? `
                <div class="section">
                    <div class="section-title">Cancellation Comments</div>
                    <div>${req.cancellation_comments}</div>
                </div>` : ''}

                <div class="footer">
                    <p>This is a legacy record imported from LimitLIS (Backup date: July 21, 2025)</p>
                    <p>Printed: ${new Date().toLocaleString()}</p>
                </div>

                <script>window.onload = function() { window.print(); }</script>
            </body>
            </html>
        `);
        printWindow.document.close();
    }

    generatePDF = (r) => {
        const { selectedPatient } = this.state;
        apiInterfaceForJson('/legacyLimitlis/pdf', 'POST', {
            mrn: selectedPatient.mrn,
            requisitionId: r._id
        }).then(res => {
            if (res && res.data && res.data.pdf_path) {
                window.open('/public_files' + res.data.pdf_path, '_blank');
            } else {
                alert('PDF generation failed');
            }
        }).catch(err => {
            console.error('PDF error:', err);
            alert('PDF generation failed: ' + err.message);
        });
    }

    render() {
        const { patients, search, loading, stats, selectedPatient, selectedRequisition, requisitions, loadingReqs, total } = this.state;

        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <h4 className="page-title">
                            <i className="fas fa-history mr-2"></i>
                            LimitLIS Legacy Data
                        </h4>
                    </div>
                </div>

                {stats && (
                    <div className="row mb-3">
                        <div className="col-md-3">
                            <div className="card text-center">
                                <div className="card-body py-2">
                                    <h3 className="text-primary mb-0">{stats.patients?.toLocaleString()}</h3>
                                    <small>Legacy Patients</small>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="card text-center">
                                <div className="card-body py-2">
                                    <h3 className="text-success mb-0">{stats.requisitions?.toLocaleString()}</h3>
                                    <small>Legacy Requisitions</small>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div className="row">
                    <div className="col-md-4">
                        <div className="card">
                            <div className="card-header py-2">
                                <h6 className="mb-1">Patient Search</h6>
                                <form onSubmit={this.handleSearch} className="d-flex">
                                    <input
                                        type="text"
                                        className="form-control form-control-sm mr-2"
                                        placeholder="Name or MRN..."
                                        value={search}
                                        onChange={e => this.setState({ search: e.target.value })}
                                    />
                                    <button type="submit" className="btn btn-primary btn-sm">Search</button>
                                </form>
                            </div>
                            <div className="card-body p-0" style={{ maxHeight: '550px', overflowY: 'auto' }}>
                                {loading ? (
                                    <div className="text-center p-4">Loading...</div>
                                ) : (
                                    <table className="table table-hover table-sm mb-0">
                                        <thead className="thead-light">
                                            <tr>
                                                <th>Name</th>
                                                <th>MRN</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {patients.map(p => (
                                                <tr
                                                    key={p._id}
                                                    onClick={() => this.selectPatient(p)}
                                                    style={{ cursor: 'pointer', background: selectedPatient?._id === p._id ? '#e3f2fd' : '' }}
                                                >
                                                    <td>{p.last_name}, {p.first_name}</td>
                                                    <td>{p.mrn}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                                <div className="p-2 text-muted" style={{fontSize:'11px'}}>Showing {patients.length} of {total}</div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-8">
                        {selectedPatient ? (
                            <div>
                                <div className="card mb-2">
                                    <div className="card-body py-2">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h6 className="mb-0">{selectedPatient.last_name}, {selectedPatient.first_name} {selectedPatient.middle_name || ''}</h6>
                                            <small className="text-muted">MRN: {selectedPatient.mrn}</small>
                                        </div>
                                        <div className="row mt-1" style={{fontSize:'12px'}}>
                                            <div className="col-md-3"><b>DOB:</b> {this.formatDate(selectedPatient.date_of_birth)}</div>
                                            <div className="col-md-2"><b>Sex:</b> {selectedPatient.sex || '-'}</div>
                                            <div className="col-md-3"><b>Phone:</b> {selectedPatient.phone || '-'}</div>
                                            <div className="col-md-4"><b>Address:</b> {selectedPatient.address || '-'}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card">
                                    <div className="card-header py-2">
                                        <h6 className="mb-0">Requisitions ({requisitions.length})</h6>
                                    </div>
                                    <div className="card-body p-0">
                                        {loadingReqs ? (
                                            <div className="text-center p-4">Loading...</div>
                                        ) : requisitions.length === 0 ? (
                                            <div className="text-center p-4 text-muted">No requisitions found</div>
                                        ) : (
                                            <table className="table table-sm mb-0">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th>Barcode</th>
                                                        <th>Collection Date</th>
                                                        <th>Status</th>
                                                        <th>Diagnoses</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {requisitions.map(r => (
                                                        <tr key={r._id} style={{background: selectedRequisition?._id === r._id ? '#f0f4f8' : ''}}>
                                                            <td><strong>{r.barcode}</strong></td>
                                                            <td>{this.formatDate(r.collection_date)}</td>
                                                            <td>
                                                                <span className={`badge badge-${r.status === 'released' ? 'success' : 'warning'}`} style={{fontSize:'10px'}}>
                                                                    {r.status}
                                                                </span>
                                                            </td>
                                                            <td style={{ maxWidth: '180px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize:'11px' }}
                                                                title={r.diagnoses}>
                                                                {r.diagnoses || '-'}
                                                            </td>
                                                            <td>
                                                                <button
                                                                    className="btn btn-xs btn-outline-secondary mr-1"
                                                                    onClick={() => this.printRequisition(r)}
                                                                    title="Quick Print"
                                                                >
                                                                    <i className="fas fa-print"></i>
                                                                </button>
                                                                <button
                                                                    className="btn btn-xs btn-outline-danger"
                                                                    onClick={() => this.generatePDF(r)}
                                                                    title="Generate PDF"
                                                                >
                                                                    <i className="fas fa-file-pdf"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="card">
                                <div className="card-body text-center text-muted p-5">
                                    <i className="fas fa-user fa-3x mb-3 d-block"></i>
                                    <p>Select a patient to view their legacy requisitions</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default LegacyLimitlisGrid;
